import {getId, getType} from 'apis/model/base'
import React, {useContext, useState} from 'react'
import {BsAward, BsCalendar2Week} from 'react-icons/bs'
import {IoInformationCircleOutline} from 'react-icons/io5'
import useTranslate from 'modules/local/useTranslate'
import CourseClassContext from '../../CourseClassContext'
import CourseSchedulePanel from 'views/Workspace/Course/containers/CourseSchedulePanel'
import {CourseClassTabHeader} from '../components/CourseClassTabHeader'
import CourseClassMyGradeResultTab from './CourseClassMyGradeResultTab'

// "Tổng quan"/"Chi tiết" (2 sub-tab cũ dạng cây theo môn học) đã bỏ khỏi tab này từ trước - component
// TimetableTree/TimetableTreeDetails trước ở đây đã xoá hẳn (không còn nơi nào dùng).
//
// Sub-tab "Điểm danh của tôi" (MyClassSessionsPanel - danh sách buổi + trạng thái điểm danh CỦA
// CHÍNH mình + tài liệu/ghi chú từng buổi) trước đây đứng RIÊNG cạnh "Lịch học" trong 1 Tabs - BỎ
// hẳn tab riêng này (theo yêu cầu, tránh trùng nội dung): pane "Sắp tới" của CourseSchedulePanel bên
// dưới (khi truyền course_class_id) giờ hiện THẲNG MyClassSessionsPanel (xem CourseSchedulePanel.js)
// - không còn 2 chỗ cùng hiện 1 nội dung nữa.
//
// CourseSchedulePanel.js (khối "Thống kê lịch học & phòng học" - Sắp tới/Dạng List/Dạng Calendar,
// đã dùng ở Workspace) thay TimetableCalendar cũ (antd Calendar trơn, ô ngày rỗng không nhãn), khoá
// sẵn course_class_id = lớp đang xem (item.id) nên chỉ còn đúng data của lớp này (API đã hỗ trợ
// filter course_class_id sẵn, không lọc lại ở client). hideActionLinks=true - link "Vào lớp"/"Xem
// chi tiết" của CourseSchedulePanel trỏ theo ?rel= (chỉ có ý nghĩa trong Workspace/access-portal),
// vô nghĩa ở trang /classroom/:id này (route theo path) và cũng thừa vì đang đứng sẵn trên đúng
// trang của lớp đó rồi.
//
// Tab cha "Lịch trình & Tiến độ" (courseClassRouteEntities.js) gồm 2 sub-tab nội bộ: "Lịch học &
// Điểm danh" (khối cũ ở trên) và "Điểm số & Kết quả" (CourseClassMyGradeResultTab, self-service -
// chỉ hiện khi is_student=true, ẩn hẳn sub-tab + switcher với người xem thuần GV/admin không đồng
// thời là học viên lớp này, khi đó tab cha chỉ còn đúng 1 khối lịch học như trước).
const CourseClassTimetableTab = () => {
    const t = useTranslate()
    const {item} = useContext(CourseClassContext)
    const isStudent = !!item?.available_actions?.is_student
    const [current, setCurrent] = useState('schedule')

    const owner_id = getId(item?.owner)
    const owner_type = getType(item?.owner)
    const course_class_id = getId(item)

    const subTabs = [
        {key: 'schedule', icon: <BsCalendar2Week size={12}/>, label: t('schedule and attendance tab')},
        {key: 'grades', icon: <BsAward size={12}/>, label: t('grades and results')},
    ]

    return (
        <div className="flex flex-col gap-3">
            {isStudent && (
                <>
                    {/* Mô tả TAB CHA "Lịch trình & Tiến độ" - đặt TRƯỚC sub-tab switcher (đúng vị trí
                        bạn chỉ, cùng cách CourseClassAttendanceTab.js đặt banner trước
                        CourseClassTabHeader) để giải thích tab này gồm 2 phần trước khi người xem
                        chọn sub-tab nào. KHÁC banner "schedule tab guide description" bên dưới (mô tả
                        RIÊNG sub-tab "Lịch học & Điểm danh", chỉ hiện khi đang ở sub-tab đó) - bạn xác
                        nhận banner đó đã ổn, giữ nguyên không đổi.
                        Chỉ hiện khi isStudent=true - cùng điều kiện với switcher (người xem thuần GV/
                        admin không phải học viên lớp này thì tab cha chỉ còn 1 khối lịch học, không
                        có 2 phần để mô tả). */}
                    <div className="px-3 py-2 flex items-center gap-2 background-100 border border-color-100 rounded-lg">
                        <IoInformationCircleOutline size={15} className="text-color-400 flex-shrink-0"/>
                        <span className="text-xs text-color-300 leading-snug">
                            {t('schedule and progress overview description')}
                        </span>
                    </div>
                    <CourseClassTabHeader
                        tabs={subTabs}
                        activeKey={current}
                        onTabChange={setCurrent}
                    />
                </>
            )}
            {(!isStudent || current === 'schedule') ? (
                <>
                    {/* Sĩ số đã dời lên header trang (ClassroomHeader/CourseClassPage.js) - thay bằng
                        banner mô tả nội dung/hướng dẫn cho nội dung bên dưới - CÙNG style banner
                        hướng dẫn đang dùng ở tab Điểm danh (CourseClassAttendanceTab.js: icon + nền
                        indigo-50 + viền indigo-100), thay bản cũ chỉ chữ nghiêng đơn giản, cho đồng bộ
                        giữa các tab. */}
                    <div className="px-3 py-2 flex items-center gap-2 bg-indigo-50 border border-indigo-100 rounded-lg">
                        <IoInformationCircleOutline size={15} className="text-indigo-500 flex-shrink-0"/>
                        <span className="text-xs text-indigo-700 leading-snug">
                            {t('schedule tab guide description')}
                        </span>
                    </div>
                    <CourseSchedulePanel
                        owner_id={owner_id}
                        owner_type={owner_type}
                        course_class_id={course_class_id}
                        title="class schedule statistics"
                        hideEyebrow
                        hideActionLinks
                    />
                </>
            ) : (
                <CourseClassMyGradeResultTab/>
            )}
        </div>
    )

}

export default CourseClassTimetableTab
